/* eslint-disable no-shadow,consistent-return,no-param-reassign,no-console */
import apiBoard from '@/services/jApiBoard';
import apiApplication from '@/services/jApiApplication';
import apiUser from '@/services/jApiUser';

const state = {
  // Set default state(s) here
  state_board: {
    boardId: null,
    boardTabActive: 'board',
    newFormId: null,
    newBoardId: null,
    board: [],
    stages: {}, // list stage is on state_board.stages.stages
    stages_total_amount: {},
    assignees: [],
    assignee_ids: [],
    temp_cards: [],
    more_temp_cards: [],
    cards: [],
    // filteredCards: [],
    filteredCardsParam: null,
    labels: [],
    newDiscussionId: null,
    users: [],
    list_updated: false,
    detail: null,
    card_activity_log: [],
  },
  cards_changes: false,
  card_detail: null,
  boards_updated: false,
  form_detail: null,
  component_created: false,
};

const getters = {
  getAssigneeOptions(state) {
    return state.state_board.assignees.map(assignee => (
      {
        id: assignee.user_company_id,
        name: assignee.email,
      }
    ));
  },
  getBoardOptions(state) {
    return state.state_board.board.map(board => (
      {
        id: board.id,
        label: board.name,
      }
    ));
  },
  getStageOptions(state) {
    return state.state_board.stages.stages.map(stage => (
      {
        id: stage.id,
        name: stage.name,
      }
    ));
  },
};

const mutations = {
  saveBoardId(state, payload) {
    state.state_board.boardId = payload;
  },
  saveBoardTabActive(state, payload) {
    state.state_board.boardTabActive = payload;
  },
  saveBoards(state, payload) {
    state.state_board.board = payload;
  },
  saveNewFormId(state, payload) {
    state.state_board.newFormId = payload.id;
  },
  saveNewBoardId(state, payload) {
    state.state_board.newBoardId = payload.id;
  },
  saveStages(state, payload) {
    state.state_board.stages = payload;
  },

  saveStagesTotalAmount(state, payload) {
    state.state_board.stages_total_amount = payload;
  },

  saveTempCards(state, payload) {
    state.state_board.temp_cards = payload;
  },

  saveMoreTempCards(state, payload) {
    state.state_board.more_temp_cards = payload;
  },

  saveCards(state, payload) {
    state.state_board.cards = payload;
    state.cards_changes = !state.cards_changes;
  },

  saveCardSelectedField(state, payload) {
    state.cards_changes = !state.cards_changes;
    state.state_board.cards.forEach((el, key) => {
      payload.forEach((field) => {
        if (el.value_id === field.id) {
          state.state_board.cards[key].field_data = field.data;
        }
      });
    });
  },
  // saveFilteredCards(state, payload) {
  //   state.state_board.filteredCards = payload;
  // },
  saveFilteredCardsNew(state, payload) {
    state.state_board.filteredCardsParam = payload;
  },
  saveLabels(state, payload) {
    state.state_board.labels = payload;
  },
  addLabels(state, payload) {
    const cardIndex = state.state_board.cards.findIndex(card =>
      card.id === Number(payload.board_card_id));
    if (cardIndex > -1) {
      const labelIndex = state.state_board.labels.findIndex(label => label.id === payload.label_id);
      if (labelIndex > -1) {
        const newLabel = state.state_board.labels[labelIndex];
        state.state_board.cards[cardIndex].label.push(newLabel);
        state.cards_changes = !state.cards_changes;
      }
    }
  },
  updateLabels(state, payload) {
    const labelIndex = state.state_board.labels.findIndex(label =>
      label.id === Number(payload.label.id));
    if (labelIndex > -1) {
      state.state_board.labels[labelIndex].name = payload.label.name;
      state.cards_changes = !state.cards_changes;
    }
  },
  deleteLabels(state, payload) {
    const cardIndex = state.state_board.cards.findIndex(card =>
      card.id === Number(payload.cardId));
    if (cardIndex > -1) {
      const labelIndex = state.state_board.cards[cardIndex].label.findIndex(
        label => label.id === payload.labelId);
      if (labelIndex > -1) {
        state.state_board.cards[cardIndex].label.splice(labelIndex, 1);
        state.cards_changes = !state.cards_changes;
      }
    }
  },
  // For jDetailRecordPage
  saveLabelsPage(state, payload) {
    state.state_board.labels = payload;
  },
  // For jDetailRecordPage
  addLabelsPage(state, payload) {
    const labelDetail = state.state_board.labels.find(el => el.id === payload.label_id);
    state.card_detail.label.push(labelDetail);
  },
  // For jDetailRecordPage
  updateLabelsPage(state, payload) {
    // Change state_board
    const labelIndex = state.state_board.labels.findIndex(label =>
      label.id === Number(payload.label.id));
    state.state_board.labels[labelIndex].name = payload.label.name;

    // Change card_detail
    const labelIndexCard = state.card_detail.label.findIndex(el => el.id === payload.label.id);
    state.card_detail.label[labelIndexCard].name = payload.label.name;
  },
  // For jDetailRecordPage
  deleteLabelsPage(state, payload) {
    const labelIndex = state.card_detail.label.findIndex(el => el.id === payload.labelId);
    state.card_detail.label.splice(labelIndex, 1);
  },
  updateCardNameAndDueDate(state, payload) {
    const cardIndex = state.state_board.cards.findIndex(card =>
      card.id === Number(payload.id));
    if (cardIndex > -1) {
      state.state_board.cards[cardIndex].name = payload.name;
      state.state_board.cards[cardIndex].due_date = payload.due_date;
      state.cards_changes = !state.cards_changes;
    }
  },
  saveAssigneeIds(state, payload) {
    state.state_board.assignee_ids = payload;
  },
  saveUsers(state, payload) {
    state.state_board.users = payload; // deleted soon, replaced by assignees
    state.state_board.assignees = payload;
  },
  addBoardAssignee(state, payload) {
    state.state_board.assignees.push(payload);
  },
  removeBoardAssignee(state, payload) {
    const assigneeIndex = state.state_board.assignees.findIndex(assignee =>
      assignee.user_company_id === Number(payload.user_company_id));
    if (assigneeIndex > -1) {
      state.state_board.assignees.splice(assigneeIndex, 1);
    }
  },
  // For jKanban and jCardDetailRecord
  updateCardAssignee(state, payload) {
    const cardIndex = state.state_board.cards.findIndex(card =>
      card.id === Number(payload.card.id));
    if (cardIndex > -1) {
      state.state_board.cards[cardIndex].assigned_to = payload.card.assigned_to;
      state.state_board.cards[cardIndex].assigned_multiple = payload.card.assigned_multiple;
      state.cards_changes = !state.cards_changes;
    }
  },
  // For jCardDetailRecordPage
  updateCardAssigneePage(state, payload) {
    state.card_detail.assigned_to = payload.card.assigned_to;
    state.card_detail.assigned_multiple = payload.card.assigned_multiple;
  },
  saveNewDiscussionId(state, payload) {
    const cardIndex = state.state_board.cards.findIndex(card =>
      card.id === Number(payload.id));
    if (cardIndex > -1) {
      state.state_board.cards[cardIndex].discussion_id = payload.discussion_id;
      state.cards_changes = !state.cards_changes;
    }
  },

  setCardDetail(state, payload) {
    state.card_detail = payload;
  },
  setCardActivityLog(state, payload) {
    state.state_board.card_activity_log = payload;
  },

  boardsUpdated(state) {
    state.boards_updated = !state.boards_updated;
  },

  setDetailForm(state, data) {
    state.form_detail = data;
  },

  componentCreated(state) {
    state.component_created = !state.component_created;
  },
};

const actions = {

  async actionGetBoards({ dispatch, commit }) {
    try {
      const res = await apiBoard.getBoards();
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('saveBoards', res.data);
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  // ------------------------------------------------------------------

  async actionGetBoardAssignees({ dispatch, commit }, data) {
    try {
      const res = await apiBoard.getBoardAssignees(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('saveAssigneeIds', res.data);
        console.log(res.data);
        const req = {
          pagination: {
            limit: 0,
            page: 0,
            column: 'id',
            ascending: true,
          },
          user_company_ids: res.data,
          includes: [
            'organigrams',
          ],
        };

        dispatch('actionGetListUserByIds', req);
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionUpdateBoardAssignees({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    let response;
    try {
      // first hit
      const res = await apiBoard.updateBoardAssignees(data);
      response = res;

      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else if (data.operation === 'add') {
        const req = {
          pagination: {
            limit: 0,
            page: 0,
            column: 'id',
            ascending: true,
          },
          user_company_ids: [data.user_company_id],
          includes: [
            'organigrams',
          ],
        };

        // second hit
        const res2 = await apiUser.listUserByIds(req);
        if (res2.error) {
          dispatch('jStoreNotificationScreen/toggleProblem', res2.message, { root: true });
        } else {
          commit('addBoardAssignee', res2.data[0]);

          // third hit
          const payload = {
            mode: 'create',
            organigram_id: res2.data[0].organigrams ? res2.data[0].organigrams[0].id : 0,
            mapping: [{
              id: 0,
              form_id: data.form_id,
              rule_id: 0,
              is_delete: false,
            }],
          };
          const res3 = await apiBoard.createOrganigramFormRule(payload);
          if (res3.error) {
            dispatch('jStoreNotificationScreen/toggleProblem', res3.message, { root: true });
            dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
          } else {
            dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
          }
        }
      } else {
        commit('removeBoardAssignee', res.data);
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      response = err.response.data;
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return response;
  },

  // ------------------------------------------------------------------

  async actionGetBoardStages({ dispatch, commit }, data) {
    try {
      const res = await apiBoard.getBoardStages(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('saveStages', res.data);
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionCreateBoardStages({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiBoard.createBoardStages(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        const boardId = Number(data.board_id);
        dispatch('actionGetBoardStages', boardId);
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionUpdateBoardStages({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiBoard.updateBoardStages(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        const boardId = Number(data.board_id);
        dispatch('actionGetBoardStages', boardId);
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        // dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionDeleteBoardStages({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiBoard.deleteBoardStages(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        const boardId = Number(data.board_id);
        dispatch('actionGetBoardStages', boardId);
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  // ------------------------------------------------------------------

  async actionGetStageAmount({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });

    try {
      const res = await apiBoard.getStageAmount(data.stage_id);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        const response = {
          ...res.data,
          stage_id: data.stage_id,
          index: data.index,
        };
        commit('saveStagesTotalAmount', response);
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  // ------------------------------------------------------------------

  async actionGetCards({ dispatch, commit }, data) {
    let res;
    try {
      res = await apiBoard.getCards(data.req, data.params);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('saveTempCards', res.data);
      }
    } catch (err) {
      res = err.response.message;
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }

    return res;
  },

  async actionGetCardsByStage({ dispatch, commit }, data) {
    let res;
    try {
      res = await apiBoard.getCardsByStage(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('saveTempCards', res.data);
      }
    } catch (err) {
      res = err.response.message;
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }

    return res;
  },


  async actionGetMoreCardsByStage({ dispatch, commit }, data) {
    let res;
    try {
      res = await apiBoard.getMoreCardsByStage(data.param);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        const response = {
          index: data.index,
          dataResponse: res.data,
        };
        commit('saveMoreTempCards', response);
      }
    } catch (err) {
      res = err.response.message;
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }

    return res;
  },

  // ------------------------------------------------------------------

  async actionGetCardSelectedField({ dispatch, commit }, data) {
    try {
      const res = await apiBoard.getFormListBatchCustomThree(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('saveCardSelectedField', res.data);
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  // ------------------------------------------------------------------


  async actionUpdateCardAssignee({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiBoard.changeAssignee(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('updateCardAssignee', res.data);
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        // dispatch('jStoreNotificationScreen/toggleSuccess', res.messages, { root: true });
      }
      return res;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response;
    }
  },

  async actionUpdateCardAssigneePage({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiBoard.changeAssignee(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('updateCardAssigneePage', res.data);
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        dispatch('jStoreNotificationScreen/toggleSuccess', res.messages, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  // ------------------------------------------------------------------

  async actionGetLabelList({ dispatch, commit }, data) {
    try {
      const res = await apiBoard.getLabelList(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('saveLabels', res.data);
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionMappingCardLabel({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiBoard.mappingCardLabel(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('addLabels', res.data);
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionDeleteMappingCardLabel({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiBoard.deleteMappingCardLabel(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('deleteLabels', data);
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionUpdateCardLabel({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiBoard.updateCardLabel(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('updateLabels', {
          cardId: data.cardId,
          label: res.data,
        });
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionGetLabelListPage({ dispatch, commit }, data) {
    try {
      const res = await apiBoard.getLabelList(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('saveLabelsPage', res.data);
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionMappingCardLabelPage({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiBoard.mappingCardLabel(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('addLabelsPage', res.data);
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionDeleteMappingCardLabelPage({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiBoard.deleteMappingCardLabel(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('deleteLabelsPage', data);
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionUpdateCardLabelPage({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiBoard.updateCardLabel(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('updateLabelsPage', {
          cardId: data.cardId,
          label: res.data,
        });
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },


  // ------------------------------------------------------------------

  async actionMoveCard({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    let res;
    try {
      res = await apiBoard.moveCard(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        const boardId = Number(data.boardId);
        dispatch('actionGetBoardStages', boardId);
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async actionChangeOrderCard({ dispatch }, { cardId, params }) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    let res;
    try {
      res = await apiBoard.changeOrderCard(cardId, params);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.messages, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        // dispatch('jStoreNotificationScreen/toggleSuccess', res.messages, { root: true });
      }
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async actionUpdateCardStage({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    let res;
    try {
      res = await apiBoard.moveCard(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        const boardId = Number(data.boardId);
        dispatch('actionGetBoardStages', boardId);
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  // ------------------------------------------------------------------

  async actionCreateCardDiscussion({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiBoard.createCardDiscussion(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('saveNewDiscussionId', res.data);
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  // ------------------------------------------------------------------

  async actionGetListUserByIds({ dispatch, commit }, req) {
    try {
      console.log(req);
      const res = await apiUser.listUserByIds(req);
      console.log(res);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('saveUsers', res.data);
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionCreateBoardAssignees({ dispatch, commit }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiUser.listUserByIds(req);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('saveUsers', res.data);

        // second hit
        const payload = {
          mode: 'create',
          organigram_id: res.data.organigrams ? res.data.organigrams[0].id : 0,
          mapping: [{
            id: 0,
            form_id: state.state_board.newFormId,
            rule_id: 0,
            is_delete: false,
          }],
        };

        const res2 = await apiBoard.createOrganigramFormRule(payload);
        if (res2.error) {
          dispatch('jStoreNotificationScreen/toggleProblem', res2.message, { root: true });
        } else {
          dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        }

        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  // ------------------------------------------------------------------

  async actionGetCardActivityLog({ dispatch, commit }, data) {
    try {
      const res = await apiBoard.getCardsActivityLog(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('setCardActivityLog', res.data);
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  // ------------------------------------------------------------------

  async actionGetCardById({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiBoard.getCardById(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('setCardDetail', res.data);
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  // ------------------------------------------------------------------

  async actionUpdateCard({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiBoard.updateCard(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('updateCardNameAndDueDate', res.data);
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionArchiveCard({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    let res;
    try {
      res = await apiBoard.archiveCard(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.messages, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        dispatch('jStoreNotificationScreen/toggleSuccess', res.messages, { root: true });
      }
    } catch (err) {
      res = err.response;
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.messages, { root: true });
    }
    return res;
  },

  async actionDeleteCard({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    let res;
    try {
      res = await apiBoard.deleteCard(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', '', { root: true });
        dispatch('jStoreNotificationScreen/toggleSuccess', res.messages, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/hideLoading', res.messages, { root: true });
      }
    } catch (err) {
      res = err.response;
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.messages, { root: true });
    }
    return res;
  },

  // ------------------------------------------------------------------

  async actionSaveFilteredCards({ commit }, data) {
    commit('saveFilteredCards', data);
  },

  // ------------------------------------------------------------------

  async createForm({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    try {
      const res = await apiBoard.createForm(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('saveNewFormId', res.data);
        const reqBoard = {
          name: data.name,
          input_type: 1,
          input_value: res.data.id,
          user_company_ids: [localStorage.getItem('userCompanyId')],
        };
        const res2 = await apiBoard.createBoards(reqBoard);
        if (res2.error) {
          dispatch('jStoreNotificationScreen/toggleProblem', res2.message, { root: true });
        } else {
          dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
          dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
          commit('saveNewBoardId', res2.data);
          commit('boardsUpdated');
        }
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.message, { root: true });
    }
  },

  async updateForm({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', '', { root: true });
    try {
      const res = await apiBoard.updateForm(data.form);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
      commit('boardsUpdated');
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.message, { root: true });
    }
  },

  async detailForm({ dispatch, commit }, data) {
    let response;
    try {
      const detailForm = await apiBoard.detailForm(data);
      response = detailForm;
      commit('setDetailForm', detailForm);
    } catch (err) {
      response = err;
      dispatch('jStoreNotificationScreen/toggleProblem', 'Form not yet created', { root: true });
    }
    return response;
  },

  // ------------------------------------------------------------------

  async sendExportBoard({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let response;
    try {
      const res = await apiBoard.sendExportBoard(req);
      response = res;
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      response = err;
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return response;
  },

  async generateExcelExportMonitoringDetail({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let response;
    try {
      const res = await apiBoard.generateExcelExportMonitoringDetail(req);
      response = res;
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      response = err;
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return response;
  },


  // ------------------------------------------------------------------

  async updateComponent({ dispatch, commit }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    try {
      const createDiv = await apiApplication.updateComponent(req);
      commit('componentCreated');
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', createDiv.message, { root: true });
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  // ------------------------------------------------------------------

  async actionUpdateVisibilityPrivilege({ dispatch }, { boardId, params }) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiBoard.updateVisibilityPrivilege(boardId, params);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.messages, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        dispatch('jStoreNotificationScreen/toggleSuccess', res.messages, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  // ------------------------------------------------------------------

  async actionUpdateEmailReminder({ dispatch }, { boardId, params }) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiBoard.updateEmailReminder(boardId, params);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.messages, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        dispatch('jStoreNotificationScreen/toggleSuccess', res.messages, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  // ------------------------------------------------------------------

  async actionSearchCard({ commit }, data) {
    commit('saveFilteredCardsNew', data);
  },

  // ------------------------------------------------------------------

  async actionSearchCardApi({ dispatch }, data) {
    let response;
    try {
      const searchCard = await apiBoard.searchCard(data);
      response = searchCard;
    } catch (err) {
      response = err;
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.message, { root: true });
    }
    return response;
  },

  // ------------------------------------------------------------------

};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/stores/jStoreBoard.js